import { axios as request } from '@/utils/request'
import { setStore, getStore } from '@/utils/storage'
import qs from 'qs'
import { ExpertLogin } from '@/views/login/api/LoginApi'
import { SYS_TITLE,SYS_LOGO,CONSULT_TELE_PHONE,COMPANY_WEBSITE } from '@/store/mutation-types'
import { GetContentResourceByKey,GetPurchaseItemLimitNumAndConsultTelePhone } from '@/epp/sysContentMange/api/sysContentMangeApi'
import Vue from 'vue'

const uuidv4 = require('uuid/v4')
const platform = require('platform')

export const TokenKey = 'Access-Token'

export function getDeviceId () {
  let deviceId = getStore('Device-Id')
  if (!deviceId) {
    deviceId = uuidv4()
    setStore('Device-Id', deviceId)
  }
  return deviceId
}

export function login (params) {
  params.deviceId = getDeviceId()
  params.deviceName = platform.name + ' ' + platform.version
  params.os = platform.os.toString()
  return request.post('/api/2/device/secure_login.json', qs.stringify(params))
}

export function expertLogin (params) {
  return ExpertLogin(params)
}

export function getInfo () {
  return request({ url: '/api/1/user/info.json', method: 'get' })
}

export function logout () {
  return request({ url: '/api/1/device/logout.json', method: 'post' })
}

export async function getSysTitle(){
  const res = await GetContentResourceByKey(SYS_TITLE,'0')
  const websiteRes = await GetContentResourceByKey(COMPANY_WEBSITE,'0')
  const ress = await GetPurchaseItemLimitNumAndConsultTelePhone()
  let consult_telePhone = "";
  if(ress.code==200){
    consult_telePhone = ress.result.consult_telePhone
  }
  Vue.ls.set(SYS_TITLE,res)
  Vue.ls.set(CONSULT_TELE_PHONE,consult_telePhone)
  Vue.ls.set(COMPANY_WEBSITE,websiteRes)
  return res
}

export async function getSysLogo(){
  const res = await GetContentResourceByKey(SYS_LOGO,'0')
  return res
}
